import { Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup } from "@material-ui/core";
import { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Airway, { AIRWAY_LEVEL_BOTH, AIRWAY_LEVEL_HIGH, AIRWAY_LEVEL_LOW } from "../layers/Airway";

const useStyles = makeStyles((theme) => ({
  checkLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12
  },
  inputLabel: {
    fontSize:"12px"
  },
}));


function LegendAirway({contents: airway}) {
  const classes = useStyles();
  const [level, setLevel] = useState(airway.getLevel());
  const [labelState, setLabelVisibleState] = useState(airway.getLabelVisibleState());
  const [contentsState, setContentsState] = useState(airway.getContentsVisibleState());

  const handleLevelChange = useCallback(event => {
    airway.setLevel(event.target.value);
    setLevel(event.target.value);
  }, [airway]);

  const toggleLabelState = useCallback(event => {
    airway.setLabelVisibleState(event.target.checked);
    setLabelVisibleState(event.target.checked);
  }, [airway]);


  const toggleContents = useCallback(event => {
    airway.setVisible(event.target.checked, event.target.name);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [airway, contentsState]);

  return (
    <div>
    <RadioGroup row aria-label="position" name="rdo-data-type" value={level}>
      <FormControlLabel value={AIRWAY_LEVEL_BOTH} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>Both</span>} onChange={handleLevelChange}/>
      <FormControlLabel value={AIRWAY_LEVEL_HIGH} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>High</span>} onChange={handleLevelChange}/>
      <FormControlLabel value={AIRWAY_LEVEL_LOW}  control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>Low</span>} onChange={handleLevelChange}/>
    </RadioGroup>
    <FormGroup>
      <FormControlLabel
        control={<Checkbox checked={labelState} onChange={toggleLabelState} name={Airway.AIRWAY_LABEL} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            Airway Name
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Airway.AIRWAY_INTERNATIONAL_NAME]} onChange={toggleContents} name={Airway.AIRWAY_INTERNATIONAL_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            RNAV(ICAO)
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Airway.AIRWAY_DOMESTIC_NAME]} onChange={toggleContents} name={Airway.AIRWAY_DOMESTIC_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            RNAV
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Airway.AIRWAY_OTHER_NAME]} onChange={toggleContents} name={Airway.AIRWAY_OTHER_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            Other
          </span>
        }
      />
    </FormGroup>
    </div>
  )
}

export default LegendAirway;